import { call, takeEvery, put, delay, select } from "redux-saga/effects";
import {
  addUserProfile,
  addUserProfileSuccess,
  addUserProfileFailure
} from "../../actions/AddProfile";
import { restoreLogin } from "../../actions/RestoreLogin";
import { addUserProfileRequest } from "../../../api/requests/AddProfile";
import showSuccessWindow from "../../../../../common/components/successPopup/successPopup";
import { message } from "antd";

import history from "../../../../../common/history";
import * as URLs from "../../../../../common/constants/systemUrls";
import { successAddProfile } from "../../../components/AddProfile/success";
import { addCompanyPhoto } from "../../../api/requests/AddProfile/addCompanyPhoto";
import { getSubjectIdBySubjectKeyRequest } from "../../../../../common/api/filters/getSubjectIdBySubjectKeyRequest";

const getUserId = state => {
  return (
    state.Authorization &&
    state.Authorization.user &&
    state.Authorization.user.id
  );
};

function* addProfileSaga(action) {
  let roleId = 2; // Создаем Админа
  let userId = yield select(getUserId);

  if (userId) {
    try {
      const { payload } = action;
      const subjectId = yield call(
        getSubjectIdBySubjectKeyRequest,
        payload.AddLicensee.subjectKey
      );
      const response = yield call(
        addUserProfileRequest,
        { ...payload, AddLicensee: { ...payload.AddLicensee, subjectId } },
        roleId,
        userId
      );
      yield put(addUserProfileSuccess(response));
      showSuccessWindow(successAddProfile());
      let { companyId } = response.data.companyId;
      let { companyPhoto } = action.payload.AddLicensee;
      if (companyId && companyPhoto) {
        yield call(addCompanyPhoto, companyId, companyPhoto);
      }
      yield put(restoreLogin());
      yield delay(1500);
      history.push("/" + URLs.AUTHORIZATION + "/" + URLs.PROFILES_LIST);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        message.error(err.response.data.message);
      }
      yield put(addUserProfileFailure(err));
    }
  } else {
    yield delay(500);
    // roleId = yield select(getUserRole);
    roleId = 2; // Создаём Админа
    userId = yield select(getUserId);
    roleId && userId
      ? yield put(addUserProfile(action.payload))
      : history.push("/authorization/profiles");
  }
}

export function* addProfileWatcher() {
  //Создаем профиль
  yield takeEvery(addUserProfile.toString(), addProfileSaga);
}
